import { useEffect, useState } from 'react';
import { IConfig } from '../../../../interface/game';
import { AframeListener } from '../js/aframeListener';
import { renderARElements } from '../../../../helper/ar';
import AroundSceneInit from './AroundSceneInit';
import { loadScript } from '../../../../util/script';
import ARCaptureBtn from '@/component/common/Button/ARCaptureBtn/ARCaptureBtn';
import GameTimer from '../GameTimer';

const scripts = [
  {
    uri: 'https://aframe.io/releases/1.6.0/aframe.min.js',
  },
  {
    uri: 'https://cdn.jsdelivr.net/gh/c-frame/aframe-extras@7.4.0/dist/aframe-extras.min.js',
  },
];
type AroundContentProps = {
  config?: IConfig;
};
const AroundContent = ({ config }: AroundContentProps) => {
  const [isAframeListenerLoaded, setIsAframeListenerLoaded] = useState(false);
  const [isScriptLoaded, setScriptLoaded] = useState(false);
  const renderElements = () => {
    const elements = config?.elements || [];
    renderARElements(elements);
  };

  const onLoadScripts = async () => {
    for (const item of scripts) {
      await loadScript(item.uri);
    }
    setScriptLoaded(true);
  };
  useEffect(() => {
    onLoadScripts();
    if (!isScriptLoaded) return;
    if (isAframeListenerLoaded) {
      const scene: any = document.querySelector('a-scene');
      if (scene && scene.hasLoaded) {
        renderElements();
      } else if (scene) {
        scene.addEventListener('loaded', renderElements);
      }
    }
    if (!isAframeListenerLoaded) {
      new AframeListener();
      setIsAframeListenerLoaded(true);
    }
  }, [isAframeListenerLoaded, isScriptLoaded]);

  if (!isAframeListenerLoaded) return <></>;
  return (
    <section id="markerless" className="relative w-full h-full">
      <AroundSceneInit />
      <ARCaptureBtn videoId="webcam" />
      <GameTimer timer={config?.timer} />
    </section>
  );
};

export default AroundContent;
